import React, { Component } from 'react'
import { Mutation } from 'react-apollo'
import { gql } from 'apollo-boost'
import { Field, Control, Input, Title, Subtitle, Button } from 'bloomer'
import { Link } from 'react-router-dom'

import { AUTH_TOKEN_KEY } from '../../constants'

import ValidateModule from './ValidadeModule'

const REGISTER_AS_USER = gql`
  mutation ($username: String!, $password: String!, $email: String!, $firstName: String!, $lastName: String!) {
    registerUser(username: $username, password: $password, email: $email, firstName: $firstName, lastName: $lastName) {
      user { id, username, email, firstName, lastName }
    }
  }
`

const LOGIN = gql`
  mutation Login($username: String!, $password: String!) {
    tokenAuth(username: $username, password: $password) {
      token
    }
  }
`

class SignUpForm extends Component {

  state = {
    firstName: '',
    lastName: '',
    email: '',
    username: '',
    password: '',
    moduleValidated: false,
    isLoading: false
  }

  handleChange = (key) => (evt) => {
    const value = evt.target.value
    this.setState(() => ({[key]: value}))
  }

  validate = () => {
    const { username, password, firstName, lastName, email } = this.state

    return !(
      username === '' ||
      password === '' ||
      firstName === '' ||
      lastName === '' ||
      email === ''
    )
  }

  handleSubmit = async (loginMutation, registerMutation, evt) => {
    evt.preventDefault()

    const { loginHandler } = this.props
    const { username, password, firstName, lastName, email } = this.state

    if (!this.validate()) {
      return
    }

    this.setState(() => ({ isLoading: true }))
    localStorage.removeItem(AUTH_TOKEN_KEY)
    try {
      await registerMutation({
        variables: { username, password, firstName, lastName, email }
      })

      const result = await loginMutation({
        variables: { username, password }
      })

      const { token } = result.data.tokenAuth
      localStorage.setItem(AUTH_TOKEN_KEY, token)
      await loginHandler()
    } catch (e) {
      this.setState(() => ({ isLoading: false }))
    }
  }

  handleModuleValidation = (value) => {
    this.setState(() => ({moduleValidated: value}))
  }

  render() {
    const { username, password, firstName, lastName, email, isLoading, moduleValidated } = this.state
    const { toggleHandler } = this.props

    if (!moduleValidated) {
      return <ValidateModule validateHandler={this.handleModuleValidation} toggleHandler={toggleHandler} />
    }

    return (
      <Mutation mutation={LOGIN}>
       {(login) => (
         <Mutation mutation={REGISTER_AS_USER}>
         {register => (
          <form onSubmit={this.handleSubmit.bind(this, login, register)}>
            <Title isSize={3}>Cadastrar</Title>
            <Subtitle isSize={5}>Criar uma nova conta</Subtitle>
            <Field>
              <Control>
                <Input type="text" placeholder="Nome" autoFocus onChange={this.handleChange('firstName').bind(this)} value={firstName} />
              </Control>
            </Field>
            <Field>
              <Control>
                <Input type="text" placeholder="Sobrenome" onChange={this.handleChange('lastName').bind(this)} value={lastName} />
              </Control>
            </Field>
            <Field>
              <Control>
                <Input type="email" placeholder="Email" onChange={this.handleChange('email').bind(this)} value={email} />
              </Control>
            </Field>
            <Field>
              <Control>
                <Input type="text" placeholder="Usuário" onChange={this.handleChange('username').bind(this)} value={username} />
              </Control>
            </Field>
            <Field>
              <Control>
                <Input type="password" placeholder="Senha" onChange={this.handleChange('password').bind(this)} value={password} />
              </Control>
            </Field>
            <Field>
              <Button isColor="primary" type="submit" isFullWidth isLoading={isLoading}>Criar</Button>
            </Field>
            <Button render={(props) => <Link {...props} to="/login"/>} isFullWidth className="is-text">Já tenho conta</Button>
          </form>
         )}
         </Mutation>
       )}
      </Mutation>
    )
  }
}

export default SignUpForm



// WEBPACK FOOTER //
// ./src/pages/IdentificationPage/SignUpForm.js